import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Store } from '@ngxs/store';
import { AccountColor } from 'app/core/models';
import { AccountState } from '@state/account/state';
import { Project } from 'app/modules/projects/projects.types';
import { PanelDef } from '@shared/components/panels/panels.types';

@Component({
  selector: 'project-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
})
export class PanelHeaderComponent implements OnInit {
  @Input() panelDef: PanelDef<any>;
  @Input() project: Project;
  @Output() onEditPanel: EventEmitter<any> = new EventEmitter<any>();

  changeTitleMode = false;
  editMode: boolean;
  titleFieldDef: any;
  panelName: string;
  panelColor: any = null;

  protected store = inject(Store);

  protected readonly accountColors$: Observable<AccountColor[]> = inject(Store).select(
    AccountState.selectAccountColorsWithNone,
  );

  ngOnInit(): void {
    this.titleFieldDef = {
      name: 'panel_name',
      label: this.panelDef.title,
      type: 'text',
    };
  }

  selectHeaderColor(color: string): void {
    if (color?.toLowerCase() === 'none') {
      this.panelColor = null;
    } else {
      this.panelColor = color;
    }

    this.saveLayout();
  }

  saveLayout(): void {
    if (this.panelName) {
      this.panelDef.title = this.panelName;
    }
    if (this.panelColor) {
      this.panelDef.color = this.panelColor;
    }
    this.onEditPanel.emit(this.panelDef);
    this.toggleEditMode(false);
  }

  updateTitle(params): void {
    const currentKey = Object.keys(params)[0];
    if (currentKey === 'panel_name') {
      this.panelName = params.panel_name;
    }
  }

  toggleChangeTitleMode(): void {
    this.changeTitleMode = true;
  }

  toggleEditMode(editMode: boolean | null = null): void {
    if (editMode === null) {
      this.editMode = !this.editMode;
    } else {
      this.editMode = editMode;
    }
    this.changeTitleMode = false;
  }
}
